import {Component, Input} from '@angular/core';
import {SnackbarModule} from '@aztrix/components/snackbar';

@Component({
  selector: 'ax-subscribe-failed-snackbar',
  templateUrl: './subscribe-failed-snackbar.component.html',
  styleUrls: ['./subscribe-failed-snackbar.component.scss'],
  imports: [SnackbarModule],
  standalone: true,
})
export class SubscribeFailedSnackbarComponent {
  @Input() errorMessage: string;
}
